<template>
  <div>
    <!-- <div class="profile__dropdown-title">
      {{
        isManagerDefault ? $tr('help.personalManagerDefault') : $tr('profile.group.settingsManager')
      }}
    </div> -->

    <ul class="profile__dropdown-list">
      <li v-if="managerName" class="profile__dropdown-item">
        <i class="icon-heart"></i>
        <span>{{ managerName }}</span>
      </li>

      <li v-if="hasManagerPhone" class="profile__dropdown-item">
        <a :href="`tel:${managerPhone}`" target="_blank">
          <i class="icon-phone"></i>
          <span>{{ managerPhone }}</span>
        </a>
      </li>

      <li v-if="managerEmail" class="profile__dropdown-item">
        <a :href="`mailto:${managerEmail}`" target="_blank">
          <i class="icon-envelope"></i>
          <span>{{ managerEmail }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PersonalManagerInfo',

  props: {
    manager: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    managerInfoLoading() {
      return this.managerInfo ? this.managerInfo.loading : null;
    },

    isManagerDefault() {
      return this.managerInfo ? this.managerInfo.isManagerDefault : false;
    },

    managerEmail() {
      return this.managerInfo ? this.managerInfo.email : '';
    },

    managerPhone() {
      return this.managerInfo ? this.managerInfo.phone : '';
    },

    hasManagerPhone() {
      return this.managerPhone && this.managerPhone.length > 5;
    },

    managerName() {
      if (!this.managerInfo) {
        return '';
      }

      const lastName = this.managerInfo.last_name;
      const firstName = this.managerInfo.first_name;
      const secondName = this.managerInfo.second_name;

      if (this.is_japan_locale) {
        return [lastName, firstName].filter(v => !!v).join(' ');
      } else {
        return [firstName, secondName, lastName].filter(v => !!v).join(' ');
      }
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    compoundName() {
      return [this.managerName, this.managerPhone, this.managerEmail]
        .filter(v => !!v)
        .join('<br/>');
    },

    managerInfo() {
      return this.manager;
    }
  }
};
</script>

<style lang="scss" scoped>
.personal-manager {
  .personal-manager__group {
    margin-bottom: 11px;
  }
}
</style>
